// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2023-03-30

import { AjinConfig } from "@ajin/config/ajin.config";

export const ajinConfig: AjinConfig = {
	id: '2e5e15af-6586-446b-9e32-38bec3bec77c',
	version: "25.05.30",
	code: 8022,
	name: 'Workers',
	key: '3160c0fa-e7dc-4761-8a08-f78e85c88e7e',
	icon: '',
	label: 'x',
	date: {
		format: 'dd/MM/yyyy',
		locale: 'pt-BR',
		placeholder: 'dd/mm/aaaa'
	},
	time: {
		format: 'HH:mm',
		locale: 'pt-BR',
		placeholder: 'hh:mm'
	},
	datetime: {
		format: 'dd/MM/yyyy HH:mm',
		locale: 'pt-BR',
		placeholder: 'dd/mm/aaaa hh:mm'
	},
	currency: {
		prefix: 'R$',
		format: '1.2-2',
		locale: 'pt',
		placeholder: '0,00'
	},
	number: {
		decimalFormat: '1.2-2',
		integerFormat: '1.0-0',
		locale: 'pt',
		placeholder: '0,00',
		thousandSeparator: ".",
		decimalMarker: ","
	},
	percentage: {
		format: '1.3-3',
	},
	timezone: '-3:00',
	logo: {
		menu: 'worker/assets/images/logo/app.svg',
		mainLight: 'worker/assets/images/logo/app-name.svg',
		mainDark: 'worker/assets/images/logo/app-name-on-dark.svg',
		authLight: 'worker/assets/images/logo/logo-auth.svg',
		authDark: 'worker/assets/images/logo/logo-auth-dark.svg',
	},

	signUp: {
		enabled: false
	},
	signIn: {
		stayConnectedEnabled: false
	}


};



